var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg2Wheeler(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.503,
    height: 17.282,
    viewBox: "0 0 27.503 17.282",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_175882",
    "data-name": "Group 175882",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_165",
    "data-name": "Ellipse 165",
    cx: 4.334,
    cy: 4.334,
    rx: 4.334,
    ry: 4.334,
    transform: "translate(0 7.613)",
    fill: "none",
    stroke: "#f47321",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_166",
    "data-name": "Ellipse 166",
    cx: 1.901,
    cy: 1.901,
    rx: 1.901,
    ry: 1.901,
    transform: "translate(2.433 10.046)",
    fill: "none",
    stroke: "#f47321",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_167",
    "data-name": "Ellipse 167",
    cx: 4.334,
    cy: 4.334,
    rx: 4.334,
    ry: 4.334,
    transform: "translate(17.834 7.613)",
    fill: "none",
    stroke: "#f47321",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_168",
    "data-name": "Ellipse 168",
    cx: 1.901,
    cy: 1.901,
    rx: 1.901,
    ry: 1.901,
    transform: "translate(20.267 10.046)",
    fill: "none",
    stroke: "#f47321",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173298",
    "data-name": "Path 173298",
    d: "M26.276,18.858a5.883,5.883,0,0,0-8.614,6.577l-6.45.014a5.886,5.886,0,0,0-5.183-7.344A5.868,5.868,0,0,0,1.55,19.628",
    transform: "translate(-1.188 -12.015)",
    fill: "none",
    stroke: "#f47321",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173299",
    "data-name": "Path 173299",
    d: "M47.2,11.533,41.822.5h-3",
    transform: "translate(-25.596 -0.5)",
    fill: "none",
    stroke: "#f47321",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1312",
    "data-name": "Line 1312",
    x1: 3.223,
    transform: "translate(12.969 11.585)",
    fill: "none",
    stroke: "#f47321",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173300",
    "data-name": "Path 173300",
    d: "M5.588,11.48h6.971a.586.586,0,0,1,.587.587v1.108a.586.586,0,0,1-.587.587H4.453a.571.571,0,0,1-.573-.573h0A1.71,1.71,0,0,1,5.588,11.48Z",
    transform: "translate(-2.714 -7.691)",
    fill: "none",
    stroke: "#f47321",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173301",
    "data-name": "Path 173301",
    d: "M37.466,6.09H33.684A2.953,2.953,0,0,0,30.73,9.044v.569a.616.616,0,0,0,.614.614h8.137L37.466,6.09Z",
    transform: "translate(-20.298 -4.161)",
    fill: "none",
    stroke: "#f47321",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173302",
    "data-name": "Path 173302",
    d: "M54.426,6.421V3.536a.338.338,0,0,0-.39-.335c-.711.117-2.143.518-2.136,1.8S53.253,6.669,53.977,6.8a.381.381,0,0,0,.449-.376Z",
    transform: "translate(-34.162 -2.266)",
    fill: "none",
    stroke: "#f47321",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173303",
    "data-name": "Path 173303",
    d: "M40.617,22.56H34.74a.77.77,0,0,0-.77.77v.6a.77.77,0,0,0,.77.77h4.393",
    transform: "translate(-22.42 -14.947)",
    fill: "none",
    stroke: "#f47321",
    strokeLinecap: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2Wheeler);
export default __webpack_public_path__ + "static/media/2_wheeler.0405b60dcf8103dd177b3c66a2718a76.svg";
export { ForwardRef as ReactComponent };